import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket/store/type'
import { type IResponseEventCallerIdVerificationResult } from 'entities/Phone/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventNumberCallerIdVerification = () => {
  const { numbersStore, websocket } = useEntitiesContext()
  const handle = (data: IResponseEventCallerIdVerificationResult) => {
    const number = numbersStore.getItem(data.number_id)

    if (number) number.updateNumberCallerId(data)
  }

  useEffect(() => websocket.on(WebsocketEvent.NumberCallerIdVerificationResult, handle), [])
}
